interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function NewspaperIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M5.25 2.5C4.83437 2.5 4.5 2.83438 4.5 3.25V12.75C4.5 13.0125 4.45625 13.2656 4.37187 13.5H13.75C14.1656 13.5 14.5 13.1656 14.5 12.75V3.25C14.5 2.83438 14.1656 2.5 13.75 2.5H5.25ZM2.25 15C1.00625 15 0 13.9937 0 12.75V3.5C0 3.08437 0.334375 2.75 0.75 2.75C1.16562 2.75 1.5 3.08437 1.5 3.5V12.75C1.5 13.1656 1.83438 13.5 2.25 13.5C2.66563 13.5 3 13.1656 3 12.75V3.25C3 2.00625 4.00625 1 5.25 1H13.75C14.9937 1 16 2.00625 16 3.25V12.75C16 13.9937 14.9937 15 13.75 15H2.25ZM5.5 4.25C5.5 3.83437 5.83437 3.5 6.25 3.5H9.25C9.66562 3.5 10 3.83437 10 4.25V6.75C10 7.16563 9.66562 7.5 9.25 7.5H6.25C5.83437 7.5 5.5 7.16563 5.5 6.75V4.25ZM11.75 3.5H12.75C13.1656 3.5 13.5 3.83437 13.5 4.25C13.5 4.66563 13.1656 5 12.75 5H11.75C11.3344 5 11 4.66563 11 4.25C11 3.83437 11.3344 3.5 11.75 3.5ZM11.75 6H12.75C13.1656 6 13.5 6.33437 13.5 6.75C13.5 7.16563 13.1656 7.5 12.75 7.5H11.75C11.3344 7.5 11 7.16563 11 6.75C11 6.33437 11.3344 6 11.75 6ZM6.25 8.5H12.75C13.1656 8.5 13.5 8.83437 13.5 9.25C13.5 9.66562 13.1656 10 12.75 10H6.25C5.83437 10 5.5 9.66562 5.5 9.25C5.5 8.83437 5.83437 8.5 6.25 8.5ZM6.25 11H12.75C13.1656 11 13.5 11.3344 13.5 11.75C13.5 12.1656 13.1656 12.5 12.75 12.5H6.25C5.83437 12.5 5.5 12.1656 5.5 11.75C5.5 11.3344 5.83437 11 6.25 11Z" />
    </svg>
  );
}
